
import Vue from "vue";
import { mapState } from "vuex";
import Modal from "@/components/Modal.vue";
import Typography from "@/components/Typography.vue";
import RoundButton from "@/components/RoundButton.vue";
import { IRootState } from "@/store/types";
import { UI } from "@/store/ui";
import { REFERENCE_DATA } from "@/store/referenceData";
import { alphaNum, maxLength, required } from "vuelidate/lib/validators";

export default Vue.extend({
  components: {
    Modal,
    Typography,
    RoundButton
  },
  props: {
    label: String,
    type: Number,
    isOpen: Boolean
  },
  data() {
    return {
      description: "",
      code: ""
    };
  },
  computed: {
    showModal: {
      get(): boolean {
        return this.isOpen;
      },
      set(value: boolean) {
        this.$emit("update:isOpen", value);

        // reset the form whenever the modal is closed
        if (!value) {
          (this.$refs.form as any).reset();

          this.$store.commit(
            REFERENCE_DATA.NS(
              REFERENCE_DATA.MUTATIONS.SET_ADD_NEW_DIALOG_ERROR_MESSAGE
            ),
            ""
          );
        }
      }
    },
    ...mapState({
      isLoading: (state: IRootState) => state.referenceData.isLoading,
      errorMessage: (state: IRootState) =>
        state.referenceData.addNewDialogErrorMessage
    })
  },
  methods: {
    async onCreate() {
      const newReferenceData = {
        description: this.description,
        code: this.code
      };

      await this.$store.dispatch(
        REFERENCE_DATA.NS(REFERENCE_DATA.ACTIONS.CREATE_REFERENCE_DATA_ITEM),
        {
          referenceDataId: this.type,
          item: newReferenceData
        }
      );

      // check if any errors occured
      if ((this as any).errorMessage === "") {
        this.showModal = false;
        this.$emit("created", newReferenceData);
      }
    }
  },
  validations: {
    description: {
      required,
      maxLength: maxLength(100)
    },
    code: {
      alphaNum, // TODO: unsure if should allow special characters. (shouldn't allow spaces)
      maxLength: maxLength(10)
    }
  }
});
